import { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  Switch,
  IconButton,
  Stack,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import AddIcon from "@mui/icons-material/Add";
import toast from "react-hot-toast";
import * as services from "../../services/services";
import { useNavigate } from "react-router-dom";
import AppBreadcrumbs from "../../components/AppBreadcrumbs";


export default function HospitalListPage() {
  const [rows, setRows] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchHospitals();
  }, []);

  const fetchHospitals = async () => {
    try {
      const res = await services.getHospitals();
      setRows(res.data.data || []);
    } catch (err) {
      toast.error("โหลดข้อมูลไม่สำเร็จ");
    }
  };

  const toggleHospital = async (id) => {
    try {
      await services.toggleHospital(id);
      toast.success("อัปเดตสถานะสำเร็จ");
      fetchHospitals();
    } catch {
      toast.error("อัปเดตไม่สำเร็จ");
    }
  };

  const deleteHospital = async (id) => {
    if (!window.confirm("ต้องการลบโรงพยาบาลนี้หรือไม่?")) return;

    try {
      await services.deleteHospital(id);
      toast.success("ลบสำเร็จ");
      fetchHospitals();
    } catch {
      toast.error("ลบไม่สำเร็จ");
    }
  };

  const columns = [
    { field: "name", headerName: "ชื่อโรงพยาบาล", flex: 1 },
    { field: "email", headerName: "Email", flex: 1 },
    { field: "phoneNumber", headerName: "เบอร์", flex: 0.5, minWidth: 50 },
    { field: "province", headerName: 'จังหวัด', flex: 1},
    {
      field: "isDisable",
      headerName: "การใช้งาน",
      width: 120,
      renderCell: (params) => (
        <Switch
          checked={!params.row.isDisabled}
          onChange={() => toggleHospital(params.row.id)}
        />
      ),
    },

    {
      field: "actions",
      headerName: "จัดการ",
      width: 150,
      renderCell: (params) => (
        <Stack direction="row" spacing={1}>
          <Button
            color="primary"
            variant="outlined"
            startIcon={<VisibilityIcon />}
            onClick={() => navigate(`/hospitals/${params.row.id}`)}
          >
            แก้ไข
          </Button>

          <IconButton
            color="error"
            onClick={() => deleteHospital(params.row.id)}
          >
            <DeleteIcon />
          </IconButton>
        </Stack>
      ),
    },
  ];

  return (
    <Box p={3}>
      <AppBreadcrumbs />
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Typography variant="h5" fontWeight={600}>
          จัดการโรงพยาบาล
        </Typography>

        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => navigate("/hospitals/create")}
        >
          เพิ่มโรงพยาบาล
        </Button>
      </Box>

      {/* TABLE */}
      <Box sx={{ height: 500 }}>
        <DataGrid
          rows={rows}
          columns={columns}
          getRowId={(row) => row.id}
          pageSize={10}
          rowsPerPageOptions={[10, 20, 50]}
        />
      </Box>
    </Box>
  );
}
